import { type DeliveryStoreSummaryResponse } from '@Src/types/deliveryStoreTypes';
import { type SupportedLanguage } from '@Src/middlewares/utils/constants';
import { logger } from '@Src/utility/loggerService';
import Cookies from 'js-cookie';

const baseUrl = 'https://api.flipdish.co';

export type GetDeliverySummariesParamsType = {
  Latitude: string;
  Longitude: string;
  skip?: string;
  count?: string;
  deviceId?: string;
  deliveryLocationId?: string;
};
const getDeliveryStoreSummaries = async (
  appId: string,
  language: SupportedLanguage,
  params: GetDeliverySummariesParamsType,
  version?: string,
): Promise<DeliveryStoreSummaryResponse> => {
  try {
    const headers = {
      'Flipdish-Language': language,
      'Content-Type': 'application/json',
      'Flipdish-App-Type': 'Web',
      'Flipdish-App-Version': version || '',
      'Flipdish-White-Label-Id': appId,
      'X-Flipdish-Token': Cookies?.get('flipdish-token') || '',
    };

    const url = `${baseUrl}/Restaurant/DeliveryRestaurantSummaries`;
    const response = await fetch(
      url + '?' + new URLSearchParams(params).toString(),
      {
        method: 'GET',
        headers,
      },
    );
    return await response.json();
  } catch (e: any) {
    logger.error(`getDeliveryStoresx for ${appId || 'undefined'}`, {
      message: e.message,
    });
    console.log('error', e);
    throw e;
  }
};

export { getDeliveryStoreSummaries };
